import React, { Component } from 'react';
import { Link } from 'react-router-dom';

// Import Images
import bg1 from '../../images/background/line-bg1.png';
import vid from '../../images/main-banner/Office Tour.MP4'
// import vid2 from '../../images/main-banner/Office Tour1.mp4'
// import ptImg1 from '../../images/shap/circle-orange.png';
// import ptImg2 from '../../images/shap/plus-orange.png';
// import ptImg3 from '../../images/shap/circle-dots.png';

class aboutSection extends Component{
	render(){
		return(
			<>
				
				<section className="section-area section-sp5 work-area" style={{backgroundImage: "url("+bg1+")", backgroundRepeat:" no-repeat", backgroundPosition: "center", backgroundSize: "100%"}}>
					<div className="container-sm">
						{/* <div className="heading-bx text-center">
							<h6 className="title-ext text-secondary">Our Office</h6>
							<h2 className="title">Take a Tour!</h2>
						</div> */}
						
						<div className="row align-items-center">
							<div style={{ maxWidth: '360px', margin: '0 auto' }}>
							<div style={{ position: 'relative', paddingTop: '177.78%' }}>
								<video style={{ position: 'absolute', top: -25, left: -0, width: '100%', height: '100%', objectFit: 'contain' }} autoPlay
								muted
								loop
								>
								<source src={vid} type="video/mp4" />
								Your browser does not support the video tag.
								</video>

								{/* <div></div>

								<video style={{ position: 'absolute', top: 0, left: 250, width: '100%', height: '100%', objectFit: 'contain' }} controls>
								<source src={vid2} type="video/mp4" />
								Your browser does not support the video tag.
								</video> */}
							</div>
							</div>

							<div className="col-lg-6 mb-30">
								<div className="heading-bx">
									<h6 className="title-ext text-secondary">Our Office</h6>
									<h2 className="title">Take a Tour!</h2>
									<p>Welcome to our state-of-the-art, eco-friendly dental office, where cutting-edge technology meets sustainable design. As you explore the space, you'll notice sleek, modern furnishings paired with energy-efficient lighting, all crafted with eco-conscious materials. From our advanced sterilization systems to water-saving dental equipment, every detail reflects our commitment to providing top-tier care while minimizing environmental impact. Experience a calm, welcoming atmosphere designed with patient comfort in mind, ensuring that your visit is both relaxing and environmentally responsible.</p>
								</div>
								
								{/* <Link to="/team" className="btn btn-primary shadow">Read More</Link> */}
							</div>
						
						</div>
						<div className="spacing" style={{ margin: '30px 0' }}></div>
						<div className="row justify-content-center">
						<div className="col-lg-10 mb-30">
								<div className="heading-bx text-center">
									<h6 className="title-ext text-secondary">Interested in Our Staff?</h6>
									<h2 className="title">Skilled Team, Exceptional Dental Care</h2>
									<p>Our dental team is a group of highly skilled professionals dedicated to providing exceptional care. With diverse expertise, from general dentistry to specialized treatments, we work collaboratively to ensure every patient receives personalized attention. We are committed to creating a welcoming environment where comfort, trust, and patient satisfaction are our top priorities. Together, we strive to make your dental experience as pleasant and effective as possible, helping you achieve a healthy, beautiful smile.</p>
								</div>
								
								<Link to="/team" className="btn btn-primary shadow">Read More</Link>
						</div>
						</div>
						<div className="row justify-content-center">
							{/* <div style={{ position: 'relative', paddingBottom: '177.78%', height: 0, overflow: 'hidden' }}>
								<video style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover' }} controls>
									<source src={vid} type="video/mp4" />
									Your browser does not support the video tag.
								</video>
							</div> */}
							<div className="col-lg-4 col-sm-6 mb-30">
								<div className="work-bx" style={{ overflow: 'hidden' }}> 
									<div className="row align-items-center">
										<div className="col-6"> {/* Using col-2 to allow full control on all screen sizes */}
											<div className="work-num-bx">01</div> {/* Adjusted to fit mobile better style={{ fontSize: '3rem' }}*/}
										</div>
										
									</div>

									<div className="work-content">
										<h5 className="title text-secondary mb-10">Make Appointment</h5>
										<p>Give us a phone call or send us an appointment request to schedule your visit.</p>
									</div>
									<Link to="/booking" className="btn btn-primary light">
										View More <i className="btn-icon-bx fas fa-chevron-right"></i>
									</Link>
								</div>
							</div>
							<div className="col-lg-4 col-sm-6 mb-30">
								<div className="work-bx" style={{ overflow: 'hidden' }}>
									{/* <div className="work-num-bx">02</div> */}
									<div className="row align-items-center">
										<div className="col-6"> {/* Using col-2 to allow full control on all screen sizes */}
											<div className="work-num-bx">02</div> {/* Adjusted to fit mobile better style={{ fontSize: '3rem' }}*/}
										</div>
										
									</div>

									<div className="work-content">
										<h5 className="title text-secondary mb-10">New Patient Exam</h5>
										<p>When you come in we'll give you our comprehensive exam and layout your treatment plan.</p>
									</div>
										<a href="https://www.tiktok.com/@familyecodental/video/7344147650125597994?is_from_webapp=1&sender_device=pc&web_id=7236805328673998378" target="_blank" rel="noopener noreferrer" className="btn btn-primary shadow">
											Read More
										</a>
								</div>
							</div>
							<div className="col-lg-4 col-sm-6 mb-30">
								<div className="work-bx" style={{ overflow: 'hidden' }}>
									{/* <div className="work-num-bx">03</div> */}
									<div className="row align-items-center">
										<div className="col-6"> 
											<div className="work-num-bx">03</div>
										</div>
										
									</div>

									<div className="work-content">
										<h5 className="title text-secondary mb-10">Take Treatment</h5>
										<p>Participate in your specially curated treatment schedule for a healthier smile.</p>
									</div>
									<Link to="/services" className="btn btn-primary light">View More <i className="btn-icon-bx fas fa-chevron-right"></i></Link>
								</div>
							</div>
							
						</div>
						
						
					</div>
					{/* <img className="pt-img1 animate1" src={ptImg1} alt=""/>
					<img className="pt-img2 animate2" src={ptImg2} alt=""/>
					<img className="pt-img3 animate3" src={ptImg3} alt=""/> */}
				</section>
				
			</>
		);
	}
}

export default aboutSection;